
import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import Indicator from './indicator'
import CircularProgress from '@material-ui/core/CircularProgress';
const styles = theme => ({
  provisionalDataWarning: {
    fontSize: '11pt',
    color: '#777!important',
    fontFamily: 'Nunito Sans Light!important',
    textAlign: 'right',
    width: '100%',
    paddingRight: '10px',
  },
  hoverable: {
    backgroundColor: 'rgba(255,255,255,0)!important',
    '&:hover': {
      cursor: 'pointer',
    },
    minHeight: '300px',
    width: '100%',
    clear: 'none',
  },
  selectorImage: {
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    width: '100%',
    height: 0,
    minHeight: '250px',
    maxHeight: '300px',
    backgroundImage: 'url("/images/stat_icons.png")',
  },
});

function statisticsOverview(props) {
  const { classes } = props
  const statisticsData = props.statisticsData

  let provisionalDataWarning
  if (props.currentMode === 'historical') {
    if (props.yearSelected === (new Date()).getFullYear()) {
      
      switch (props.lang){
        case "de":
          provisionalDataWarning = "vorläufige Zahlen"
          break;
        case "en":
          provisionalDataWarning = "Preliminary figures"
          break;
        case "fr":
        default:
          provisionalDataWarning = "Chiffres préliminaires"
      }
    }
  }

  if (statisticsData === undefined)
    return <CircularProgress className={classes.progress} size={50} />
  return (

    <Grid container spacing={2}>
      {
        /*
        <Grid item xs={2}>
          <div className={classes.hoverable}>

            <div
              className={classes.selectorImage}
            //data-for='wind_tooltip' 
            //data-tip='wind_tooltip'
            //data-energy_source='wind'
            //onClick={props.setEnergySource}
            >
            </div>
            {tooltipWind}
          </div>
        </Grid>
        */
      }

      <Grid item xs={12}>
        <Indicator
          name='energy_sum'
          value={statisticsData['energy_sum'].value}
          unit={statisticsData['energy_sum'].unit}
          label={statisticsData['energy_sum'].label[props.lang]}
        />
      </Grid>
      {statisticsData.hasOwnProperty('residential_facilities') && statisticsData.hasOwnProperty('industrial_facilities') && (
        <Grid item container xs={12}>
          <Grid item xs={1}>
          </Grid>
          <Grid item xs={5}>
            <Indicator
              name='residential_facilities'
              value={statisticsData['residential_facilities'].value}
              unit={statisticsData['residential_facilities'].unit}
              label={statisticsData['residential_facilities'].label[props.lang]}
            />
          </Grid>
          < Grid item xs={6}>
            <Indicator
              name='industrial_facilities'
              value={statisticsData['industrial_facilities'].value}
              unit={statisticsData['industrial_facilities'].unit}
              label={statisticsData['industrial_facilities'].label[props.lang]}
            />
          </Grid>
        </Grid>
      )}

      <Grid item xs={12}>
        <Indicator
          name='energy_as_percentage_of_demand'
          value={Math.round(statisticsData['energy_as_percentage_of_demand'].value)}
          unit={statisticsData['energy_as_percentage_of_demand'].unit}
          label={statisticsData['energy_as_percentage_of_demand'].label[props.lang]}
        />
      </Grid>
      <Grid item xs={12}>
        <Indicator
          name='energy_as_percentage_of_demand_peak'
          value={statisticsData['energy_as_percentage_of_demand_peak'].value === 'Niet beschikbaar' ? "" : statisticsData['energy_as_percentage_of_demand_peak'].value}
          unit={statisticsData['energy_as_percentage_of_demand_peak'].unit}
          label={statisticsData['energy_as_percentage_of_demand_peak'].label[props.lang]}
          //date={props.currentMode === 'historical' ? (statisticsData['energy_as_percentage_of_demand_peak'].date ? (statisticsData['energy_as_percentage_of_demand_peak'].date.substring(8, 10) + "." + statisticsData['energy_as_percentage_of_demand_peak'].date.substring(5, 7)) : '') : ''}
          //currentMode={props.currentMode}
        />
      </Grid>

      {statisticsData.hasOwnProperty('electrical_vehicles') && (<Grid item xs={12}>
        <Indicator
          name='electrical_vehicles'
          value={Math.round(statisticsData['electrical_vehicles'].value)}
          unit={statisticsData['electrical_vehicles'].unit}
          label={statisticsData['electrical_vehicles'].label[props.lang]}
        />
      </Grid>)}
      <Grid item xs={12}>
        <Indicator
          name='co2_avoided'
          value={Math.round(statisticsData['co2_avoided'].value)}
          unit={statisticsData['co2_avoided'].unit}
          label={statisticsData['co2_avoided'].label[props.lang]}        />
      </Grid>


      <p className={classes.provisionalDataWarning}>{provisionalDataWarning}</p>
    </Grid >
  );
}

statisticsOverview.propTypes = {
  classes: PropTypes.object.isRequired,
  statisticsData: PropTypes.object,
  currentMode: PropTypes.string,
  currentTech: PropTypes.object,
  yearSelected: PropTypes.number
};

export default withStyles(styles)(statisticsOverview);
